import Dialog from "@mui/material/Dialog";
import { Clinic } from "../../models";
import { formatCentreName } from "../../helpers";

export interface ConfirmUpdateModalProps {
	clinic: Clinic;
	openMobileCheckin: boolean;
	open: boolean;
	onClose: (value: boolean) => void;
}

export const ConfirmUpdateModal = ({
	clinic,
	openMobileCheckin,
	open,
	onClose
}: ConfirmUpdateModalProps) => {
	return (
		<Dialog open={open} onClose={() => onClose(false)}>
			<div className="flex flex-col gap-8 py-8 px-8">
				<div className="ch-m-text ch-em-text-navy text-center">
					{`${openMobileCheckin ? "Open" : "Close"} mobile check in for ${formatCentreName(clinic.name)}`}
				</div>
				<div>
					You are {openMobileCheckin ? "opening" : "closing"} mobile check ins
					for {formatCentreName(clinic.name)}. Are you sure?
				</div>
				<div className="flex flex-row justify-end">
					<button
						className="ch-button ch-button-primary me-4"
						onClick={() => onClose(false)}
					>
						Cancel
					</button>

					<button
						className="ch-button ch-button-secondary"
						onClick={() => onClose(true)}
					>
						Yes
					</button>
				</div>
			</div>
		</Dialog>
	);
};
